import { render } from "./BaseSearchbar.vue?vue&type=template&id=20d79e2f"
import script from "./BaseSearchbar.vue?vue&type=script&lang=js"
export * from "./BaseSearchbar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__